import classNames from 'classnames'

import { FinancialBeautifiedValue } from 'partner360/components/financialBeautifiedValue/FinancialBeautifiedValue'

import { handleNumberColumnChange } from '../../../../helpers/handleNumberColumnChange'
import { FinancialInput } from '../../../styledComponents/financialInput/FinancialInput'
import styles from '../../Revenue.module.scss'

interface IProps {
  value: number | string
  keyValue: string
  onChange: (field: string, keyValue: string) => (value: string | number) => void
  field: string
  isEditable?: boolean
}

export const ShortYearRevenue = ({ value, keyValue, onChange, field, isEditable }: IProps) => {
  if (isEditable || keyValue === 'Revenue3D') {
    return (
      <FinancialInput
        className={classNames(styles.alignColumns, styles.alignColumns)}
        type={'number'}
        value={value || ''}
        onChange={handleNumberColumnChange({ field, keyValue, onChange })}
      />
    )
  }

  return (
    <FinancialBeautifiedValue
      className={classNames(styles.alignColumns, styles.alignColumns)}
      value={value || ''}
    />
  )
}
